module.exports = __webpack_public_path__ + "assets/images/vcr_casino-01.d113f277e2e4834628075b5472487eff.svg";